'use client';

import React from 'react';
import Link from 'next/link';
import HomepageBusSearch from './HomepageBusSearch';
import ThreeEasySteps from './ThreeEasySteps';
import EnjoyYourTrips from './EnjoyYourTrips';
import CustomerFeedback from './CustomerFeedback';
import MobileAppSection from './MobileAppSection';
import TravelBlog from './TravelBlog';
import NewsletterSignup from './NewsletterSignup';
import Footer from './Footer';

const Homepage = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="relative bg-cover bg-center py-16 md:py-32 text-white mb-12 shadow-xl"
        style={{ backgroundImage: `url('/images/bus_banner.jpg')` }}>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl font-bold mb-4">BOOK YOUR BUS TICKET</h1>
          <p className="text-lg md:text-xl mb-8 opacity-90">Choose your destinations and book your tickets in advance</p>
          <Link href="/search" className="bg-[#16A34A] hover:bg-[#128a3a] text-white font-bold py-3 px-8 rounded-md transition duration-300 transform hover:scale-105 inline-block">
            Book Now
          </Link>
        </div>
        <div className="relative z-10 -mb-20">
          <HomepageBusSearch />
        </div>
      </div>
      <div className="max-w-7xl mx-auto">

      {/* Three Easy Steps Section */}
      <ThreeEasySteps />

      {/* Enjoy Your Trips Section */}
      <EnjoyYourTrips />

      {/* Customer Feedback Section */}
      <CustomerFeedback />

       {/* Mobile App Section */}
      <MobileAppSection />
      
      {/* Travel Blog Section */}
      {/* <TravelBlog /> */}

      {/* Additional Services */}
      <div className="mb-16">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Additional Services</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl shadow-md p-6 border-t-4 border-[#16A34A]">
            <h3 className="text-xl font-bold mb-3 text-gray-800">Addmission Service</h3>
            <p className="text-gray-600 mb-4">Verify your addmission status using PNR number or QR code scanning.</p>
            <Link href="/verify-ticket" className="text-[#16A34A] font-medium hover:underline">Addmission Now →</Link>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-6 border-t-4 border-[#16A34A]">
            <h3 className="text-xl font-bold mb-3 text-gray-800">Bus Reservation</h3>
            <p className="text-gray-600 mb-4">Reprint your bus reservation using PNR number or mobile number.</p>
            <Link href="/print-ticket" className="text-[#16A34A] font-medium hover:underline">Bus Reservation Now →</Link>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-6 border-t-4 border-[#16A34A]">
            <h3 className="text-xl font-bold mb-3 text-gray-800">Learn More</h3>
            <p className="text-gray-600 mb-4">View, cancel, or reschedule your existing addmissions.</p>
            <Link href="/bookings" className="text-[#16A34A] font-medium hover:underline">Learn More →</Link>
          </div>
        </div>
      </div>
      </div>
     
      {/* Newsletter Signup Section */}
      {/* <NewsletterSignup /> */}

      {/* Footer Section */}
      <Footer />
    </>
  );
};

export default Homepage;